import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LuTrash2 } from 'react-icons/lu'
import Dialog, { btnGhost, btnDanger } from 'components/ui/Dialog'

// Modal de confirmación para eliminar un ítem de la aplicación
export default function DeleteModal({
  onClose,
  itemName,
  itemId,
  handleDelete
}) {
  const { t } = useTranslation()
  return (
    <Dialog onClose={onClose} size="sm">
      <div className="flex flex-col items-center gap-3 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
          <LuTrash2 size={22} />
        </span>
        <h3 className="text-base font-semibold text-gray-900">{t('delete_modal.title')}</h3>
        {itemName && <p className="break-words text-sm text-gray-500">&quot;{itemName}&quot;</p>}
        <div className="mt-2 flex w-full gap-2">
          <button type="button" onClick={() => onClose()} className={`${btnGhost} flex-1 justify-center`}>
            {t('cancel')}
          </button>
          <button
            type="button"
            onClick={() => {
              handleDelete(itemId)
              onClose()
            }}
            className={`${btnDanger} flex-1`}
          >
            {t('delete')}
          </button>
        </div>
      </div>
    </Dialog>
  )
}

// Define los tipos de las props que recibe el componente actual
DeleteModal.propTypes = {
  onClose: PropTypes.func,
  itemName: PropTypes.any,
  itemId: PropTypes.any,
  handleDelete: PropTypes.func
}
